import React from 'react';

const ConfirmModal = ({ isOpen, onClose, onConfirm, title, message }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>{title}</h3>
                    <button onClick={onClose} className="close-modal-btn">&times;</button>
                </div>
                <div className="modal-form">
                    <p>{message}</p>
                    <div className="modal-actions">
                        <button type="button" onClick={onClose}>Cancelar</button>
                        <button type="button" onClick={onConfirm} style={{ background: '#f44336', color: 'white' }}>Confirmar</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
